class ProductRecommendationsCustom extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const productId = this.getAttribute('product-id');
    const limit = this.getAttribute('limit') || 4;
    const currency = this.getAttribute('currency') || 'USD';
    const endpoint = `/recommendations/products.json?product_id=${productId}&limit=${limit}`;
    const formatPrice = (cents, currency) => {
      const price = cents / 100;
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2
      }).format(price);
    };

    if(this.classList.contains("have-meta")) {
      $('product-recommendations-custom .recommendations-grid').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    } else {
      try {
        const res = await fetch(endpoint);
        const data = await res.json();
        if (!data.products || data.products.length === 0) {
          return;
        }
        const productsHtml = data.products.map(product => {
          // todas las variantes
          const variantOptions = product.variants.filter(variant => variant.available).map(variant => `<option value="${variant.id}">${variant.title}</option>`).join('');
          console.log(product);
          return `
            <div class="card-recomendation-custom">
              <div class="wrapp">
                <a class="logo_card-recomendation" href="${product.url}">
                  <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
                </a>
                <div class="content">
                  <h4>${product.title}</h4>
                  <p>${formatPrice(product.price, currency)}</p>
                  <div class="btns_wrapp">
                    <div class="select_wrapp">
                      <p>Size: </p>
                      <select class="select-drawer_${product.id}">
                        ${variantOptions}
                      </select>
                    </div>
                    <button onclick="addToCartCustom(${product.id})" class="button">Add</button>
                  </div>
                </div>
              </div>
            </div>
          `;
        }).join('');
        this.innerHTML = `
          <div class="recommendations-grid">
            ${productsHtml}
          </div>
        `;
        $('product-recommendations-custom .recommendations-grid').slick({
          dots: false,
          arrows: true,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          slidesToScroll: 1,
        });
      } catch (error) {
        console.error('Error al cargar recomendaciones:', error);
      }
    }
  }
}

customElements.define('product-recommendations-custom', ProductRecommendationsCustom);

function addToCartCustom(productID) {
  let select_item = document.querySelector(`.card-recomendation-custom .select-drawer_${productID}`);
  if (select_item) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: select_item.value,
        quantity: 1
      })
    })
    .then(res => {
      if (!res.ok) throw new Error("No se pudo agregar al carrito.");
      return res.json();
    })
    .then(data => {
      fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'custom',
          cartData: cartData
        });
      });
    })
    .catch(err => {
      console.error("Error al agregar al carrito:", err);
    }); 
  }
}

// configuracion de los filtros, para abrir hover
document.addEventListener('DOMContentLoaded', () => {
  const detailsElements = document.querySelectorAll(`facet-filters-form.facets.small-hide .disclosure-has-popup.js-filter`);
  
  detailsElements.forEach((detail) => {
    
    const summary = detail.querySelector('summary');
    if (!summary) return; // si no hay summary, saltamos
    // Evita que el click abra o cierre el details
    summary.addEventListener('click', (e) => {
      e.preventDefault();
    });
    
    // Eventos para abrir/cerrar con hover solo en escritorio
    detail.addEventListener('mouseenter', () => {
      detail.setAttribute('open', '');
    });
    detail.addEventListener('mouseleave', () => {
      detail.removeAttribute('open');
    });
  });
  
});

$(document).on("click", ".menu-drawer_header_close", function () {
    $("body").toggleClass("overflow-hidden-tablet");
});
$(document).ready(function () {
    $(".testimonials .testimonial-container").slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    centerPadding: "0px",
                    slidesToShow: 1,
                },
            },
        ],
    });

    $(document).on("click", ".collec-size_guide", function (params) {
        $(".collec-size_modal").attr("open", "open");
    });
    $("a.wishlist-icon.header__icon--account").click(function (e) {
        e.preventDefault();
        const wishlistData = JSON.parse(localStorage.getItem("wishlist")) || [];
        // if (wishlistData.length === 0) {
        //   window.location.href="/pages/wishlist";
        // }
        const selected_option = wishlistData.map((item) => {
            return item.phandle;
        });
        window.location.href = "/pages/wishlist?&" + selected_option;
    });
});

// open header on hover starts
if ($(window).width() > 990) {
    $(".header__inline-menu ul li header-menu").hover(
        function () {
            $(this).children("details").attr("open", "true");
        },
        function () {
            $(this).children("details").removeAttr("open");
        }
    );
}

// open header on hover ends

$(document).on("click", ".sorting__filter label", function () {
    var srt_val = $(this).attr("data-val");
    $('.facet-filters__sort option[value="' + srt_val + '"]')
        .attr("selected", "selected")
        .siblings()
        .removeAttr("selected");
});
//............. this function work for custom sorting best seller and new .............
findSortedElement();
function findSortedElement() {
    var srt_val = $(".facet-filters__sort").find(":selected").attr("value");
    $('.sorting__filter input[data-input-val="' + srt_val + '"]').prop(
        "checked",
        true
    );
    $(
        '.mobile-facets__details.best-selling.mobile_sorting input[data-input-val="' +
            srt_val +
            '"]'
    ).prop("checked", true);
    $(
        '.mobile-facets__details.new.mobile_sorting input[data-input-val="' +
            srt_val +
            '"]'
    ).prop("checked", true);
}

let locoScroll = null;
document.addEventListener("DOMContentLoaded", function () {
  const cardProducts = document.querySelectorAll(".card-wrapper");
  cardProducts.forEach(cardproduct=>{
    if(Boolean(cardproduct.querySelector('modal-opener'))) {
      cardproduct.addEventListener("click", evt=>{
        evt.preventDefault();
        let modalOpener = cardproduct.querySelector(".quick-add button");
        const clickEvent = new Event('click');
        modalOpener.dispatchEvent(clickEvent);
        console.log(modalOpener);
      });
    }
  });
  
    if (document.querySelector(".locomotive-scroll") === null) {
        return;
    }
    //set to every direct children of locomotive-scroll the data-scroll and data-scroll-section
    const scrollSections = document.querySelectorAll(".locomotive-scroll>*");
    scrollSections.forEach((section) => {
        section.setAttribute("data-scroll-section", "");
    });

    locoScroll = new LocomotiveScroll({
        el: document.querySelector(".locomotive-scroll"),
        smooth: true,
        smartphone: {
            smooth: false,
        },
        tablet: {
            smooth: false,
        },
        multiplier: 1.0,
    });
    console.debug("Locomotive Scroll Initialized", locoScroll);

    function locomotiveHeightBug() {
        window.dispatchEvent(new Event("resize"));
    }
    setTimeout(locomotiveHeightBug, 1000);
});

/* Size gidde posicion */
document.addEventListener("DOMContentLoaded", function () {
  var miDiv = document.querySelector(".size_guideChart");
  var contenedor = document.querySelector(".product-form__header");

  if (miDiv && contenedor) {
    contenedor.appendChild(miDiv);
  }
});
function addToCartLink(item, event) {
  event.preventDefault();
  let boton_cart = document.querySelector('button[type="submit"].product-form__submit.button');
  if (boton_cart && !boton_cart.disabled) {
    item.setAttribute("disabled", "disabled");
    boton_cart.click();
    setTimeout(() => {
      item.removeAttribute("disabled");
    }, 800);
  }
}